import Reflux from 'reflux';

const TermsActions = Reflux.createActions([
  'fetch'
]);

export default TermsActions;

